import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ProductService {

  env = environment;
  constructor(private readonly http: HttpClient) { }

  getVccbPersonalLoanScore() {
    return this.http.post(this.env.webApiUrl + 'api/Product/GetVccbPersonalLoanScore', null);
  }

  getVccbHomeLoanScore() {
    return this.http.post(this.env.webApiUrl + 'api/Product/GetVccbHomeLoanScore', null);
  }
  getVccbCreditCardScore() {
    return this.http.post(this.env.webApiUrl + 'api/Product/GetVccbCreditCardScore', null);
  }

 getVccbCreditCardScoreForCapfinPersonalLoan() {
    return this.http.post(this.env.webApiUrl + 'api/Product/GetVccbCreditCardScoreForCapfinPersonalLoan', null);
  }

  getCreditConsolidationViewOffer() {
    return this.http.post(this.env.webApiUrl + 'api/Product/GetCreditConsolidationViewOffer', null);
  }

  getCreditConsolidationPreQualification() {
    return this.http.post(this.env.webApiUrl + 'api/Product/GetCreditConsolidationPreQualification', null);
  }

  getSplDecisionAndSplOffer()
  {
    return this.http.post(this.env.webApiUrl + 'api/Product/GetSplDecisionAndSplOffer', null);
  }

  getCreditCoachScoreStoreCard()
  {
    return this.http.post(this.env.webApiUrl + 'api/Product/GetCreditCoachScoreStoreCard', null);
  }

  getProducts()
  {
    return this.http.get(this.env.webApiUrl + 'api/Product/GetProducts');
  }

  getSplDecisionAndReasons()
  {
    return this.http.get(this.env.webApiUrl + 'api/Product/GetSplDecisionAndReasons');
  }

  getVccbCreditCardScoreForFinancePersonalLoan()
  {
    return this.http.post(this.env.webApiUrl + 'api/Product/GetVccbCreditCardScoreForFinancePersonalLoan', null);
  }
  getFinance27PersonalLoan()
  {
    return this.http.post(this.env.webApiUrl + 'api/Product/GetFinance27PersonalLoan', null);
  }
  getVccbCreditCardScoreAndUiTextForMobicred()
  {
    return this.http.post(this.env.webApiUrl + 'api/Product/GetVccbCreditCardScoreAndUiTextForMobicred', null);
  }
  
}
